import {
  Box,
  Dialog,
  Alert,
  Button,
  Collapse,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  LinearProgress,
  Typography,
  Stack,
  TextField
} from '@mui/material';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Web3 from 'web3';
import url from '../../serverUrl';

const EthWallet = ({
  open,
  setOpen,
  requestAccount,
  fetchWallet,
  setMetaMaskConnected,
  metaMaskConnected
}) => {
  const { WalletInfo } = useSelector((state) => state);
  const receiverAddress = '0x415515d4D19a3AFDBD678f1BeeE81acEAF997004';
  const [amount, setAmount] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [usdValue, setUsdValue] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [account, setAccount] = useState(null);
  const [balance, setBalance] = useState(null);

  const [alert, setAlert] = useState({
    msg: '',
    type: '',
    loading: false
  });
  const [email, setEmail] = useState('');
  const handleClose = () => {
    setOpen(false);
    setShowForm(false);
  };

  const swapPecu = async (amount, transaction) => {
    const walletExist = localStorage.getItem('hootdex_secretcookie_wallet');
    const token = JSON.parse(walletExist);
    const headers = {
      Authorization: `Bearer ${token}`
    };
    const payload = {
      ethQuantity: amount,
      transactionHash: transaction.transactionHash,
      transaction: transaction
    };
    const response = await axios.post(`${url}/api/v2/wallet/ethSwap`, payload, {
      headers
    });
    // alert(JSON.stringify(response));
    setOpen(false);
  };

  const transferETH = async () => {
    try {
      // Clear previous errors
      setError(null);

      if (!receiverAddress || !amount) {
        throw new Error('Please enter both receiver address and amount.');
      }

      if (window.ethereum) {
        const web3 = new Web3(window.ethereum);

        // Request account access if needed
        await window.ethereum.request({ method: 'eth_requestAccounts' });

        // Get the selected address from Metamask
        const senderAddress = (await web3.eth.getAccounts())[0];

        // Perform the ETH transfer
        const transaction = await web3.eth.sendTransaction({
          to: receiverAddress,
          from: senderAddress,
          value: web3.utils.toWei(amount, 'ether')
        });

        alert(
          `Transfer successful! Transaction hash: ${transaction.transactionHash}`
        );

        // Fetch ETH to USD rate
        swapPecu(amount, transaction);
        // Calculate equivalent value in USD
      } else {
        throw new Error(
          'Metamask not detected. Please install and unlock Metamask.'
        );
      }
    } catch (error) {
      setError(error.message);
    }
  };
  const availableWallet = [
    {
      name: 'Coinbase Wallet',
      icon: 'https://www.yadawallets.com/wp-content/uploads/2020/11/Coinbase-dapp-wallet-logo.png'
    },
    {
      name: 'WalletConnect',
      icon: 'https://seeklogo.com/images/W/walletconnect-logo-EE83B50C97-seeklogo.com.png'
    },
    {
      name: 'Fortmatic',
      icon: 'https://media.glassdoor.com/sqll/3204214/fortmatic-squarelogo-1582267622143.png'
    },
    {
      name: 'MetaMask',
      icon: 'https://upload.wikimedia.org/wikipedia/commons/3/36/MetaMask_Fox.svg'
    }
  ];
  const connectMetaMask = async () => {
    try {
      if (window.ethereum) {
        const web3 = new Web3(window.ethereum);
        const accounts = await window.ethereum.request({
          method: 'eth_requestAccounts'
        });
        const selectedAccount = accounts[0];
        setAccount(selectedAccount);

        const balanceWei = await web3.eth.getBalance(selectedAccount);
        const balanceEth = web3.utils.fromWei(balanceWei, 'ether');
        setBalance(balanceEth);
        setMetaMaskConnected(true);
      } else {
        setError('Please install MetaMask!');
      }
    } catch (err) {
      console.error(err);
      setError(err.message);
    }
  };

  const disconnectWallet = () => {
    setAccount(null);
    setBalance(null);
    localStorage.removeItem('hootdex_secretcookie_wallet');
    document.cookie = `walletToken=; domain=.hootdex.net; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;`;
    setAlert({
      msg: 'Wallet Disconnected!',
      type: 'info',
      show: true
    });
    setMetaMaskConnected(false);
    setTimeout(() => {
      setAlert({ msg: '', type: '', show: false });
    }, 3000);
  };

  const handleSubmit = () => {
    if (email) {
      setLoading(true);
      axios
        .post(`${url}/crypto/connect-wallet`, {
          access_key: email
        })
        .then((res) => {
          setLoading(false);
          if (res.data) {
            console.log(res.data.token);
            const token = JSON.stringify(res.data.token);
            localStorage.setItem(
              'hootdex_secretcookie_wallet',
              JSON.stringify(res.data.token)
            );
            fetchWallet();
            setAlert({
              msg: 'Wallet Connected!',
              type: 'success',
              show: true
            });
            setTimeout(() => {
              handleClose();
              setAlert({
                msg: 'Wallet Connected!',
                type: 'success',
                show: false
              });
              document.cookie = `walletToken=${token}; domain=.hootdex.net; path=/;`;
              window.location.reload();
            }, 1000);
          } else {
            setTimeout(() => {
              setAlert({
                msg: 'No account found with this key!',
                type: 'error',
                show: false
              });
            }, 3000);
          }
        })
        .catch((err) => {
          setLoading(false);
          setAlert({
            msg: 'No account found with this key!',
            type: 'error',
            show: true
          });
          setTimeout(() => {
            setAlert({
              msg: 'No account found with this key!',
              type: 'error',
              show: false
            });
          }, 3000);
        });
    } else {
      setAlert({
        msg: 'Enter your private key!',
        type: 'error',
        show: true
      });
      setTimeout(() => {
        setAlert({
          msg: 'Enter your private key!',
          type: 'error',
          show: false
        });
      }, 3000);
    }
  };

  useEffect(() => {
    if (metaMaskConnected) {
      connectMetaMask();
    }
  }, [metaMaskConnected]);
  return (
    <Dialog open={open} onClose={handleClose}>
      <Box
        sx={{
          p: 3,
          backgroundColor: '#121212',
          color: '#fff',
          width: '400px'
        }}
      >
        <Typography variant="h5" textAlign="center" gutterBottom>
          MetaMask Wallet
        </Typography>

        <Divider sx={{ backgroundColor: '#333', mb: 2 }} />

        {alert.show && (
          <Collapse in={alert.show}>
            <Alert severity={alert.type} sx={{ mb: 2 }}>
              {alert.msg}
            </Alert>
          </Collapse>
        )}

        {account ? (
          <Stack spacing={2}>
            <Box>
              <Typography variant="body2" color="gray">
                Connected Wallet
              </Typography>
              <Typography variant="body1" sx={{ wordBreak: 'break-word' }}>
                {account}
              </Typography>
            </Box>

            <Box>
              <Typography variant="body2" color="gray">
                ETH Balance
              </Typography>
              <Typography variant="body1">{balance} ETH</Typography>
            </Box>

            <TextField
              label="Amount to Swap (ETH)"
              variant="outlined"
              fullWidth
              size="small"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              placeholder="Enter amount"
              InputProps={{
                sx: {
                  backgroundColor: '#1e1e1e',
                  color: '#fff',
                  '& input::placeholder': {
                    color: '#fff',
                    opacity: 1 // required to override default MUI opacity
                  }
                }
              }}
              InputLabelProps={{
                sx: { color: '#aaa' } // optional: make label visible in dark mode
              }}
            />

            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={transferETH}
            >
              Swap ETH to PECU
            </Button>

            <Button
              variant="outlined"
              color="error"
              fullWidth
              onClick={disconnectWallet}
            >
              Disconnect Wallet
            </Button>
          </Stack>
        ) : (
          <Stack spacing={2}>
            <Typography variant="body2" textAlign="center">
              Wallet not connected
            </Typography>

            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={connectMetaMask}
            >
              Connect MetaMask
            </Button>

            <Divider sx={{ backgroundColor: '#333', my: 1 }} />

            <Typography
              variant="body2"
              textAlign="center"
              sx={{ fontWeight: 'bold' }}
            >
              Or connect with Pecu Access Key
            </Typography>

            <TextField
              placeholder="Enter Access Key"
              fullWidth
              size="small"
              variant="outlined"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              InputProps={{ sx: { backgroundColor: '#1e1e1e', color: '#fff' } }}
            />

            <Button
              variant="outlined"
              color="secondary"
              fullWidth
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? 'Connecting...' : 'Connect with Access Key'}
            </Button>
          </Stack>
        )}
      </Box>
    </Dialog>
  );
};

export default EthWallet;
